import carShield from "../img/car-shield.png";
import carCrashed from "../img/car-crashed.png";
import handNote from "../img/hand-note.png";
import saving1 from "../img/saving-1.png";
import saving2 from "../img/saving-2.png";
import saving3 from "../img/saving-3.png";
import bikePink from "../img/bike-pink.png";
import personExp from "../img/person-experience.png";
import discountLabel from "../img/discount-label.png";
import fastTimer from "../img/fast-timer.png";
import tapSolution from "../img/tap-solution.png";
import policies from "../img/compare-policies.png";
import support247 from "../img/support-247.svg";
import zeroPaper from "../img/zero-paper.png";
import saveTime from "../img/save-time.png";
import claimImg1 from "../img/claim-img-1.png";
import claimImg2 from "../img/claim-img-2.png";
import claimImg3 from "../img/claim-img-3.png";
import chartImg1 from "../img/chart-img1.jpeg";
import chartImg2 from "../img/chart-img2.jpeg";
import chartImg3 from "../img/chart-img3.jpeg";
import chartImg4 from "../img/chart-img4.jpeg";
const ackoContent = [
  {
    page: "car",
    subTitle:
      "Save costs, comply with law, and stay hassle-free with ACKO’s online car insurance policy.",
    reasons: [
      {
        id: "carr1",
        img: carShield,
        title: "Stay safe",
        content:
          "Car insurance, also called auto or motor insurance, is a simple and effective way to protect your car from unforeseen risks such as accidents, thefts, fire, natural disasters, or third-party liabilities.",
      },
      {
        id: "carr2",
        img: carCrashed,
        title: "Drive legal",
        content:
          "Having a valid third-party car insurance is mandatory by law when you are driving a car in India. Having good car insurance is a necessity to protect yourself from financial losses that come along with road accidents.",
      },
      {
        id: "carr3",
        img: handNote,
        title: "Just relax",
        content:
          "ACKO makes car insurance easy. Choice of coverage, add-ons and discounts to save on premiums - get them all on ACKO. During claims, enjoy our door to door pick-up, repairs and drop services.",
      },
    ],
    policyDesc:
      "Planning to buy a car insurance policy? ACKO provides different types of car insurance policies for your unique needs.",
    policies: [
      {
        id: "carp1",
        title: "Third-party Cover",
        content:
          "Owning third-party car insurance is mandatory while driving a car in India. It protects you against financial liabilities if you damage someone else’s vehicle/property or injure someone in an accident.",
      },
      {
        id: "carp2",
        title: "Own Damage Cover",
        content:
          "Third-party Liability Car Insurance cover will not help if your car gets damaged due to theft, fire, natural disasters, etc. For that, you need to opt for Own Damage Insurance policy along with the Third-party car insurance policy.",
      },
      {
        id: "carp3",
        title: "Comprehensive - Basic",
        content:
          "Comprehensive Car Insurance Cover not just secures you against third-party liability but also provides cover against damages or losses to your car due to accidents, theft, flooding, fire and more. It is advisable to opt for Comprehensive Car Insurance to give optimum protection to your vehicle and reduce financial liabilities.",
      },
      {
        id: "carp4",
        title: "Comprehensive - Super Saver",
        content:
          "Exclusive on ACKO. Enjoy Comprehensive Cover benefits and superior claim experience. During claims, ACKO will pick up your car, repair it at one of our partner garages, and deliver back at no extra cost. Only catch: if you fail to inform ACKO before any claim related repairs, you will have to pay Rs. 5,000 as a deductible.",
      },
      {
        id: "carp5",
        title: "Zero Depreciation - Basic",
        content:
          "Sometimes called the bumper to bumper plan, includes all the benefits of a Comprehensive - Basic plan while additionally covering depreciation costs of parts. Without Zero Depreciation benefits only partial costs of some parts like fibre & plastic parts are covered.",
      },
      {
        id: "carp6",
        title: "Zero Depreciation - Smart Saver",
        content:
          "Exclusive on ACKO. It has all the benefits Zero Depreciation - Basic at a discounted price. Only catch: during a claim, we pay for everything, you just pay ₹5,000 (above IRDAI/Govt. mandated charges) as a deductible. This gives upfront savings to safe drivers who think chances of them filing a claim are less.",
      },
      {
        id: "carp7",
        title: "Zero Depreciation - Super Saver",
        content:
          "Exclusive on ACKO. Enjoy Comprehensive Cover & Zero Depreciation benefits (read more below) and superior claim experience. During claims, ACKO will pick up your car, repair it at one of our partner garages, and deliver back at no extra cost. Only catch: if you fail to inform ACKO before any claim related repairs, you will have to pay Rs. 5,000 as a deductible.",
      },
      {
        id: "carp8",
        title: "Personal Accident Cover",
        content:
          "Personal Accident Cover is not a Car Insurance policy, but an additional cover to your car insurance. It is mandatory by law to own a Personal Accident Cover along with the Third-party Insurance Plan. It covers both permanent disability/death while driving a car.",
      },
    ],
    keyFeature: [
      {
        id: "ckf1",
        feature: "Premium",
        advantage: "Car insurance plans starting at Rs. 2,072",
      },
      {
        id: "ckf2",
        feature: "Add-ons",
        advantage: "8 add-ons available to enhance your insurance plan",
      },
      {
        id: "ckf3",
        feature: "Own Damage policy	",
        advantage: "Available under Comprehensive Cover",
      },
      {
        id: "ckf4",
        feature: "Damages to the third party",
        advantage: "Covered",
      },
      {
        id: "ckf5",
        feature: "Personal Accident (PA) cover",
        advantage:
          "Available. Cover of Rs. 15 lakh for permanent disability/death while driving",
      },
      {
        id: "ckf6",
        feature: "Cashless repairs	",
        advantage: "Yes",
      },
      {
        id: "ckf7",
        feature: "Claim Settlement Ratio (CSR)",
        advantage: "94% for FY20-21",
      },
      {
        id: "ckf8",
        feature: "Emergency assistance	",
        advantage: "24/7",
      },
      ,
      {
        id: "ckf9",
        feature: "Repairs	",
        advantage:
          "1-hour pickup (for select cities), instant repairs and 3-day doorstep delivery at no extra cost",
      },
      ,
      {
        id: "ckf10",
        feature: "Buying/renewal process",
        advantage: "100% digitally-driven",
      },
      ,
    ],
    benefits: {
      bTitle: "Top 3 reasons to choose ACKO for car insurance",
      bDesc:
        "We get that you would want to compare car Insurance policies and get the one that has low price, is easy to use, and provides good coverage. And that's exactly why you should pick ACKO!",
      list: [
        {
          id: "cb1",
          img: saving1,
          title: "Incredibly low premiums",
          content:
            "When you buy directly from ACKO, we don't have to pay any commissions to agents. We pass these savings to you by giving low premium rates.",
        },
        {
          id: "cb2",
          img: fastTimer,
          title: "Super easy claims",
          content:
            "ACKO provides paperless door-to-door claims. Give us a call - we will pick up your car, get it repaired and deliver it back to you within 3 working days.",
        },
        {
          id: "cb3",
          img: discountLabel,
          title: "Unique plans & discounts",
          content:
            "ACKO has unique plans tailored to your needs. They are not available anywhere else. We also have personalised discounts for our customers.",
        },
      ],
    },
  },
  {
    page: "bike",
    subTitle:
      "Low-cost bike insurance plans with exciting discounts - Buy online on ACKO.",

    reasons: [
      {
        id: "biker1",
        img: saving1,
        title: "Save costs",
        content:
          "Two-wheeler insurance, commonly called bike insurance, protects your two wheeler from financial losses against accidental damages or theft.",
      },
      {
        id: "biker2",
        img: bikePink,
        title: "Protect your bike",
        content:
          "Good bike insurance covers losses due to accidents, natural disaster, fire, theft, or riot. It also protects against injuries/damages caused to someone else or their property.",
      },
      {
        id: "biker3",
        img: personExp,
        title: "Hassle-free experience",
        content:
          "On ACKO, you can buy insurance for your two wheeler completely online in just a few minutes. No inspection or paperwork needed - even if your previous insurance has expired.",
      },
    ],
    policyDesc:
      "Our bike insurance plans cover different types of two wheelers such as motorcycles, mopeds, scooters, and more.",
    policies: [
      {
        id: "bikep1",
        title: "Third-party Bike Insurance Plan",
        content:
          "Third party Bike Insurance is mandatory in India. It protects you against financial liability if you accidentally damage someone else's vehicle or property or injure someone in an accident. However, it doesn't offer financial protection against damages or losses to your bike.",
      },
      {
        id: "bikep2",
        title: "Comprehensive Bike Insurance Plan",
        content:
          "A Comprehensive Bike Insurance covers everything that Third-party insurance covers, and also covers losses or damages to your two-wheeler in case of an accident, theft, fire, natural calamities (floods, earthquakes), riots, or strikes.",
      },
      {
        id: "bikep1",
        title: "Personal Accident (PA) Cover",
        content:
          "It is an additional cover to enhance your bike insurance plan. It is mandatory by law to own a PA Cover in India. While your bike insurance policy covers damages to your bike, the PA Cover provides financial protection in the event of disability/death while riding a two-wheeler.",
      },
    ],
    keyFeature: [
      {
        id: "bkf1",
        feature: "Premium",
        advantage: "Bike insurance plans starting at Rs. 499*",
      },
      {
        id: "bkf2",
        feature: "Own Damage Cover",
        advantage: "Available under Comprehensive Bike Insurance plan",
      },
      {
        id: "bkf3",
        feature: "Damages to the third party",
        advantage: "Covered",
      },
      {
        id: "bkf4",
        feature: "Personal Accident cover",
        advantage:
          "Available. Cover up to Rs. 15 lacs for permanent disability/death while riding",
      },
      {
        id: "bkf5",
        feature: "Claim Settlement Ratio (CSR)",
        advantage: "95% for FY20-21",
      },
      {
        id: "bkf6",
        feature: "Claims settlement process",
        advantage:
          "Quick, paperless, cashless, and stress-free. Instant claim settlements for minor damages (Within 2 hours)",
      },
      {
        id: "bkf7",
        feature: "Buying/renewal process",
        advantage: "Instant, 100% digitally-driven and super-easy",
      },
      ,
    ],
    benefits: {
      bTitle: "Benefits of buying directly from ACKO",
      bDesc:
        "Affordable premiums, instant policy issuance with no inspection or paperwork, and easy claim settlement make ACKO the perfect place to buy bike insurance online.",
      list: [
        {
          id: "bb1",
          img: saving2,
          title: "Incredibly low premiums",
          content:
            "Since we adopt the direct-to-consumer model, our customers have to pay a lower premium.",
        },
        {
          id: "bb2",
          img: fastTimer,
          title: "Super easy claims",
          content:
            "With 100% digital transactions, buying/renewing your bike insurance policy is a super-fast and hassle-free experience.",
        },
        {
          id: "bb3",
          img: handNote,
          title: "Zero hassle claims",
          content:
            "Log in to www.acko.com or the mobile app and select “claim now” to register your claim. Our experts will do the rest for you!",
        },
        {
          id: "bb4",
          img: discountLabel,
          title: "Discounts and offers",
          content:
            "Get personalised discounts during special occasions/festivals and save more money.",
        },
        {
          id: "bb5",
          img: saving3,
          title: "Optimise savings",
          content:
            "With our multi-year bike insurance plans, enjoy additional savings.",
        },
        {
          id: "bb6",
          img: tapSolution,
          title: "One-stop solution",
          content:
            "With ACKO, you can buy, renew, track and raise bike insurance claims in one place.",
        },
      ],
    },
  },
];
const notCovered = {
  desc: {
    car: "No matter which insurance plan you purchase, some costs are not covered when you buy a car insurance from ACKO. They are listed below.",
    bike: "You can select the right coverage for your two-wheeler by picking an insurance plan and renewing it on time for continuous benefits. However, there are some things that are not covered in ACKO’s Bike Insurance Policy. Following are such examples, please take a look.",
  },

  list: [
    {
      id: "nc1",
      content:
        "Accidental damages while driving under the influence of alcohol or intoxicating drugs.",
    },
    {
      id: "nc2",
      content: "Accidental damages during war or similar conditions.",
    },
    {
      id: "nc3",
      content:
        "Any claims against an incident when your insurance policy was not active.",
    },
    {
      id: "nc4",
      content:
        "Cost of repair/replacement of parts that are damaged due to regular wear and tear and not related to any incident like accident, theft, fire, flood, etc.",
    },
    {
      id: "nc5",
      content:
        "Any claims against an incident where you were driving without a valid driving licence.",
    },
    {
      id: "nc6",
      content: "Any claims related to personal items stolen from your car",
    },
  ],
};
const expiredInsurance = {
  title: "What happens if your car insurance expires?",
  desc: "You should try your best renew your car insurance in time, and never let it expire.",
  list: [
    {
      id: "exI1",
      content:
        "Driving without valid Insurance is illegal in India and can attract heavy penalties.",
    },
    {
      id: "exI2",
      content:
        "You lose out on your No Claim Bonus if you fail to renew the policy within 90 days after your policy expires.",
    },
    {
      id: "exI3",
      content:
        "If any incident like accident or theft occurs while your insurance is lapsed, it won't be covered by insurance.",
    },
    {
      id: "exI4",
      content:
        "Insurance prices usually see an increase each year. A delay in renewals might cause an increase in premium rates for you.",
    },
  ],
};
const buyCarIns = {
  title: "How to buy car insurance online from ACKO?",
  desc: "Share details, customise plans, and make the payment - that effortless it is to buy a car insurance policy. Here are 3 simple steps to buy/renew a car insurance policy from ACKO.",
  list: [
    {
      id: "bcI1",
      step: "1",
      content:
        "Scroll to the top of this page and share details such as car number, car model, and insurance policy.",
    },
    {
      id: "bcI2",
      step: "2",
      content:
        "Select from various car insurance plans with exclusive tailor-made quotes for you.",
    },
    {
      id: "bcI3",
      step: "3",
      content:
        "Select a suitable plan, make the payment, download the policy, and receive it in your inbox.",
    },
  ],
};
const buyBikeIns = {
  title: `Buy/renew bike/two wheeler insurance online in India`,
  list: [
    {
      id: `bBI1`,
      title: `What is bike insurance/two-wheeler insurance policy?`,
      content: `Bike insurance or a two wheeler insurance policy is a contract between the bike owner and the insurance provider. Here the insurance company provides financial coverage for damage/loss to the bike owner in exchange for a premium.`,
    },
    {
      id: `bBI2`,
      title: `How to buy a bike insurance policy?`,
      content: `You can buy your bike/two wheeler insurance policy through both online and offline methods. With the online method, you can buy, renew the policy or raise a claim in a few clicks from anywhere and at anytime.`,
    },
  ],
};
const reponsibleFactor = {
  title: "Factors responsible for determining the car insurance premium",
  desc: "The premium that you pay is determined by a host of factors as mentioned below.",
  list: [
    {
      id: "rF1",
      title: "Car’s engine capacity",
      content:
        "The engine cubic capacity (cc) of your car decides the premium payable on your insurance plan. In simple terms, cc is the volume of the engine’s cylinder. Higher the engine cc, the higher the premium you need to pay.",
    },
    {
      id: "rF2",
      title: "Insurance coverage",
      content:
        "The wider the cover, the costlier the policy. The premium for Third-party Policy will be lower than a Comprehensive Plan. However, the coverage will be limited. A Comprehensive Plan or full coverage car insurance might seem costlier, but it offers more protection to your car.",
    },
    {
      id: "rF3",
      title: "Insured Declared Value (IDV)",
      content:
        "Your car’s market value (also called IDV) set by the insurer determines your premium. IDV is the maximum claim you will get from the insurer. IDV changes due to wear & tear with time. Higher IDV, the higher the premium and vice-versa.",
    },
    {
      id: "rF4",
      title: "Add-on covers",
      content:
        "You can enhance the Comprehensive plan with the aid of add-ons as they add an extra layer of protection to the policy. We offer various add-ons, and you can choose one or a combination of them depending on your requirement. The more add-ons you add, the higher the premium.",
    },
    {
      id: "rF5",
      title: "Age of the car",
      content: `For a new car, the cost of replacement of the parts/repairs can be higher. Also, the car's value reduces with wear and tear. So the older the car, the lower its value, which reduces the premium amount. 
        
        However, age also makes a car more susceptible to damages. Hence, insurance companies check your car’s health while deciding the premium.`,
    },
    {
      id: "rF6",
      title: "Claims history",
      content: `If you have higher records of accidents, then the probability of damage is more, which will increase your claims. 
        
        Claim's history negatively impacts the premium you have to pay during policy renewal. Claims affect your No Claim Bonus component, and as a result, the premium will be higher.`,
    },
    {
      id: "rF7",
      title: "Deductibles",
      content: `The deductible is the amount you will have to pay while settling a claim. The insurance company will bear the rest of the approved amount.

        Other than the mandatory nominal amount you have to pay on every claim, you can opt to increase your deductibles. The higher the deductibles, the lower the premium charged.`,
    },
    {
      id: "rF8",
      title: "Other factors",
      content: `The insurance companies decide your premium based on other factors such as your location, fuel, deductibles, security features in your car, etc. 

        For example, a few areas may demand more premium due to higher traffic congestion. Also, owning a CNG car may attract more premium due to higher maintenance compared to petrol/diesel cars.`,
    },
  ],
};
const claimProcess = {
  title: "Claims process with ACKO",
  desc: "Depending on the kind of plan you have purchased, your preference and the severity of claim; there are different claim options available to you.",
  list: [
    {
      id: "cP1",
      title: "Managed claims by ACKO",
      content:
        "Just register a claim in a few minutes on ACKO's app or website, and our team will take care of the rest. One of our team members will pick up the car from your address, get it repaired at our partner garage and deliver the car back to you within 3 working days.",
    },
    {
      id: "cP2",
      title: "Cashless claims",
      content:
        "Inform ACKO about the claim before taking your car to a garage. Get the repairs done at the garage on your own. We will settle the repair bill with the garage directly to give you a cashless experience for the approved claim amount.",
    },
    {
      id: "cP3",
      title: "Instant claim settlement",
      content:
        "For minor damages such as a car’s loose bumper or damaged mirror, ACKO provides instant claim settlement. ACKO will immediately transfer the approved claim amount to your account so you can get the repairs done on your own.",
    },
    {
      id: "cP4",
      title: "Reimbursement claims",
      content:
        "In case you wish to get your car repaired at a garage of your choice, just inform ACKO first. Our team will arrange for an inspection, and you can carry out the repairs and pay at the garage. You can file for a reimbursement later, and ACKO will deposit the approved settlement amount to your account.",
    },
  ],
};
const addOneCarIns = {
  title: "Add-ons with ACKO car insurance policy",
  desc: "You can customise your car insurance plan with any of these add-ons to protect your car. They offer additional coverage for extra cost over your base policy while buying/renewing the policy.",
  list: [
    {
      id: "aOCI1",
      title: `Zero Depreciation Cover`,
      content: `Due to the wear and tear of car parts, the value of your car reduces with time. During claims, the insurance company only pays this depreciated value and not the entire value. Best suited for new cars, Zero Depreciation Add-on cover helps you escape depreciation cutbacks and get the full value of car repairs.`,
    },
    {
      id: "aOCI2",
      title: `Roadside Assistance Cover`,
      content: `Getting stranded on the road with a car that won't start is one of the biggest worries for any driver. With Roadside Assistance add-on you get access to 24x7 emergency roadside assistance, including towing services during car breakdowns.`,
    },
    {
      id: "aOCI3",
      title: `Key Replacement Cover`,
      content: `Car keys aren’t cheap and the cost can go upwards of Rs. 10,000.  With Key Replacement Cover, you can save your money on expenses incurred for replacing a lost, stolen, or damaged key and even a replaced lock, if required.`,
    },
    {
      id: "aOCI4",
      title: `Outstation Emergency Cover`,
      content: `Outstation Emergency Cover secures you against accidents/breakdowns outside a 100 km radius of your residence during the policy period. Also, enjoy a reimbursement amount (as per policy terms) if the repair time exceeds 12 hrs.`,
    },
    {
      id: "aOCI5",
      title: `Consumables Cover`,
      content: `The cost of items such as engine oil, gearbox oil, lubricants, nut and bolt, screw, etc. are not covered during claims. Consumables Cover add-on protects you from expenses incurred on these items during an accident. The good part is - all of ACKO’s plans except the Third-party Plan include this coverage at no extra cost.`,
    },
    {
      id: "aOCI6",
      title: `Engine Protection Cover`,
      content: `Flooding or not using the car for a long time can damage the engine, which is one of the most expensive parts of the car. Car insurance doesn't cover damages to your car engine. However, the Engine Protection add-on cover shields you from losses caused due to damage to your car engine.`,
    },
    {
      id: "aOCI7",
      title: `No Claim Bonus Protection`,
      content: `When you raise a claim for your car's damages, you lose out on the No Claim Bonus (NCB) discount. NCB Protection add-on cover keeps this discount intact even if you make a claim. With this add-on, you can raise a claim and still enjoy NCB discount of up to 50%.`,
    },
    {
      id: "aOCI8",
      title: `Return to Invoice Cover`,
      content: `Return to Invoice Cover comes to your rescue in case of theft or damage beyond repair. With Return to Invoice add-on cover, you can claim the complete amount as per the car's invoice value. This amount includes car registration cost and road tax as well.`,
    },
    {
      id: "aOCI9",
      title: `Personal Accident Cover for Passengers`,
      content: `Personal Accident Cover for Passengers is an extra cover for your near and dear ones. It allows you to protect your loved ones in case of unfortunate accidents leading to permanent disability/death. Under this, you can get access to coverage of up to Rs. 1 lakh per passenger.`,
    },
  ],
};
const growthCarInsIndia = {
  title: `Crystal ball gazing into the growth of the motor insurance industry`,
  desc: `The industry is all set to grow as digital adoption and personalised offerings become the North Star of the auto insurance industry.`,
  list: [
    {
      id: "gCII1",
      title: `Internet penetration `,
      content: `As per the data from Statista, internet users in India rose from 422 mn in 2017 to 761 mn by 2021, which is a compounded annual growth rate of 15.9%. This number is projected to reach approx. 974 mn by 2025. The internet penetration and a young demographic dividend will influence the growth of digital auto insurance products in India.`,
    },
    {
      id: "gCII2",
      title: `Foreign Direct Investment (FDI) inflows`,
      content: `FDI inflows stood at Rs. 26,000 crore (US$3.58 bn) since 2015. Asset under management (AUM) in the insurance sector increased by 76% over the last five years. The recent increase in FDI inflow from 49% to 74% in the insurance sector will likely propel new innovative offerings and strengthen the insurance penetration in India.`,
    },
    {
      id: "gCII3",
      title: `Growth in the automotive industry`,
      content: `Strong growth in the automotive industry and the spike in auto sales will propel the growth of auto insurance in India over the next decade. Between FY14-15 and FY18-19, the automobile domestic sales registered an average growth of 5.8% y-o-y.`,
    },
    {
      id: "gCII4",
      title: `Demographic dividend`,
      content: `With approx. 400 mn millennials and their soaring aspirations, the opportunities are humongous for auto insurance companies to acquire new customers.`,
    },
    {
      id: "gCII5",
      title: `Financial ecosystem`,
      content: `India’s strong macro-economic factors and a robust financial ecosystem make India an attractive hubspot for motor insurance products.`,
    },
  ],
};
const glimpseInsIndustry = {
  title: `A glimpse into the auto insurance industry in India`,
  list: [
    {
      id: `gII1`,
      title: `Growth in Gross Direct Premium (GDP)`,
      content: `The Indian auto insurance business registered a growth of close to 8.9% in FY18-19 and close to 7.2% in FY19-20. In FY18-19, the share of the auto insurance business in terms of Gross Direct Premium was 38% of India’s total general insurance business.`,
    },
    {
      id: `gII2`,
      title: `States contributing maximum growth`,
      content: `As per the report by IIB, this growth comes from 6 states i.e Maharashtra, Uttar Pradesh, Karnataka, Tamil Nadu, Gujarat and Delhi, which contributed close to 50% of the total policies and claims.`,
    },
    {
      id: `gII3`,
      title: `Contribution to non-life insurance premium`,
      content: `Gross Direct Premium increased from Rs. 59,246 crores in FY17-18 to Rs. 69,208 crores in FY19-20. For FY20-21, the market share of the motor insurance premium stands at approx. 34% of the overall non-life insurance premium.`,
    },
  ],
};
const whereShouldBuy = {
  title: "Online vs offline: Where should you buy?",
  desc: "While the offline or traditional method continues to exist, the online mode offers a faster, quicker, and efficient process when it comes to buying and renewing policies or while raising a claim. Here are the benefits of buying two-wheeler insurance online.",
  list: [
    {
      id: "wSB1",
      img: policies,
      title: `Compare policies`,
      content: `The online insurance platform offers you the option of selecting a suitable policy. You can compare various policies and get to know the merits and demerits of the plan.`,
    },
    {
      id: "wSB2",
      img: discountLabel,
      title: `Lower premium`,
      content: `The online method does not involve any agents. Hence, the benefit of low-costs is passed on to the customer in the form of lower premiums compared to offline policies.`,
    },
    {
      id: "wSB3",
      img: support247,
      title: `Expert assistance`,
      content: `Avail support from insurance experts who can help you throughout the process of buying and renewing policies or while registering a claim.`,
    },
    {
      id: "wSB4",
      img: zeroPaper,
      title: `Zero paperwork`,
      content: `Skip the tedious paperwork! Share a few details, select the policy, pay premium and receive the policy in your inbox instantly.`,
    },
    {
      id: "wSB5",
      img: saveTime,
      title: `Saves time`,
      content: `With online two wheeler insurance, you can transact online anywhere and anytime, which helps you save time and efforts.`,
    },

    {
      id: "wSB5",
      img: tapSolution,
      title: `One-stop solution`,
      content: `With online 2 wheeler insurance, you can not just buy bike insurance in a jiffy, but also manage and raise claims anytime and anywhere.`,
    },
  ],
};
const bikeInsTerminologies = {
  title: `Important terminologies related to two-wheeler insurance`,
  desc: `With various jargons and terminologies, insurance is made complicated. However, it is super-easy if you understand their relevance. Here are a few of the terminologies that you may want to know.`,
  list: [
    {
      id: `bIt1`,
      title: `Insured Declared Value (IDV)`,
      content: `Insured Declared Value (IDV) is the sum insured amount or the current market value of the bike. This is the amount ACKO will pay in case of a total loss due to theft, fire, riots, floods, etc. Hence, it is important to choose the right value so that you get the rightful compensation in case of a total loss. The buyer can choose the IDV while buying or renewing the policy. For two-wheelers, which are more than 5 years old, the insurer and policyholder will mutually agree on the IDV.`,
    },
    {
      id: `bIt2`,
      title: `IDV Formula
      `,
      content: `IDV is calculated as the selling price of the manufacturer minus the depreciation value. The lower the IDV, the lower the premium and vice versa.

      Example: Your bike’s market value is Rs. 75,000. You decide to reduce the IDV to Rs. 65,000 to decrease the premium. In case of theft, the insurer will pay the IDV after deducting depreciation, which is lower than the market value. Hence, you need to be careful while changing the IDV.`,
    },
    {
      id: `bIt3`,
      title: `Zero Depreciation`,
      content: `With time, the value of the bike depreciates due to wear and tear. While making a claim, the insurance company only pays this depreciated value and not the entire value. 

      With Zero Depreciation add-on cover, age does not matter since depreciation is not considered and you enjoy a higher claim settlement amount. Also, the insurer will not consider the deprecation of the replaced bike parts. Hence, you can get almost the same value of coverage by the insurer in case you have to replace a part of the bike.`,
    },
    {
      id: `bIt4`,
      title: `Consumables Cover`,
      content: `Parts such as screw, nut and bolt, lubricant, engine and gearbox oil, distilled water, A/C gas, oil, and break filter are called Consumable items. 

      The basic Comprehensive Insurance policy does not cover consumable items while settling claims. The Consumables add-on cover will pay for the specified consumable items to help you save on cost.`,
    },
    {
      id: `bIt5`,
      title: `Voluntary Deductible`,
      content: `Deductible is the part of the repair bill that you need to pay from your pocket. There are two types - Compulsory and Voluntary. Compulsory Deductible for two-wheelers is fixed at Rs. 100 by the Insurance Regulatory and Development Authority of India (IRDAI). 

      In case of Voluntary Deductible, you have the option to increase the percentage of the deductible. In return, the insurer offers a discount on the premium amount resulting in lower premiums. This is suitable when you are not sure of making claims during the policy period.
      
      Example: If your bike was damaged and the total claim amount is Rs. 6,000 and you have opted for a Voluntary Deductible of Rs. 2,000, then you have to pay Rs. 2,000 and the insurer will pay the balance amount of Rs. 4,000.`,
    },
    {
      id: `bIt6`,
      title: `No Claim Bonus`,
      content: `ACKO rewards riders with a discount for driving safely and not raising a claim during the policy period. The discount is referred to as No Claim Bonus (NCB) and can be used while renewing the policy.

      On the first two-wheeler insurance renewal, you will receive a 20% discount and it increases for five consecutive years for driving safely and not raising any claims. This discount can go up to 50%.
      
      Example: if you got a 20% discount on the first renewal of the policy and you do not file a claim the second year, the discount for the second renewal rises to 25%. Similarly, for the third, fourth and fifth consecutive no-claim years, the NCB discount becomes 35%, 45% and 50% respectively.`,
    },
  ],
};
const benefitsRenewBikeIns = {
  title: `Benefits of renewing bike insurance policy at ACKO`,
  desc: `Below are the primary benefits of renewing a two wheeler insurance online with ACKO.`,
  list: [
    {
      id: `bRBI1`,
      content: `Include useful add-on covers* that meet your requirement. *(Only if available)`,
    },
    {
      id: `bRBI2`,
      content: `Calculate the cost of your bike insurance online and play around with various factors such as IDV.`,
    },
    {
      id: `bRBI3`,
      content: `Raise claims by login into your account or via mobile app anytime and anywhere.`,
    },
    {
      id: `bRBI4`,
      content: `Pay easily through various payment options and save on time and efforts.`,
    },
    {
      id: `bRBI5`,
      content: `Instant two wheeler insurance renewal online process - completely digital, paperless and hassle-free.`,
    },
    {
      id: `bRBI6`,
      content: `Receive the policy document instantly to your registered email account.`,
    },
  ],
};
const carInsBenefits = {
  title: `Car insurance benefits in India`,
  desc: `Here are the important benefits of car insurance in India.`,
  list: [
    {
      id: `cIB1`,
      title: `Personal accident cover`,
      content: `One of the most valuable benefits of car insurance is that it offers Personal Accident (PA) cover. The PA cover provides a financial shield against permanent total disability and death caused by accident. The cover is mandatory as per law when you buy car insurance.`,
    },
    {
      id: `cIB2`,
      title: `Cover against car damage`,
      content: `To see your loved possessions damaged can sink your heart. Car insurance is an excellent option to mitigate these financial liabilities. If your car is damaged due to an accident, fire or natural/manmade calamities, car insurance will provide financial protection.`,
    },
    {
      id: `cIB3`,
      title: `Wide network of garages`,
      content: `ACKO has partnered with an extensive network of garages across the cities it operates. With access to network garages, you get to enjoy the cashless services across these locations.`,
    },
    {
      id: `cIB4`,
      title: `Third-party liability coverage`,
      content: `Damages to a third party’s property or vehicle or even injuries or the demise of the third person can cause substantial financial loss. The mandatory Third-party Car Insurance Plan offers financial protection against third-party liabilities due to an accident caused by the insured car.`,
    },
    {
      id: `cIB5`,
      title: `No Claim Bonus (NCB) advantage`,
      content: `For not filing claims during the policy period, the insurer offers a discount on the renewal premium. This discount is known as NCB. You can get a discount of up to 50% if you do not file claims for five consecutive years, making car insurance affordable.`,
    },
    {
      id: `cIB6`,
      title: `Coverage against vehicle theft`,
      content: `Another benefit of car insurance is that it provides financial protection against vehicle theft. If your car is stolen, ACKO shall pay the Insured Declared Value (IDV) stated in your policy, subject to terms and conditions.`,
    },
    {
      id: `cIB7`,
      title: `Discounts`,
      content: `ACKO offers discounts on the car insurance premium during special occasions and festivals. You can take advantage of the discount to buy an affordable car insurance policy for your vehicle.`,
    },
    {
      id: `cIB8`,
      title: `Save time and hassles`,
      content: `The cost and time taken to repair the damages may cause a lot of inconveniences. With an active car insurance plan, you rest assured that you are financially protected at all times. You also have the advantage of online car insurance, wherein you can buy or renew or raise claims within a few minutes.`,
    },
    {
      id: `cIB9`,
      title: `Death benefits to dependents`,
      content: `In case of the insured's demise due to an accident, dependents get a lumpsum compensation through the PA cover. The coverage limit is up to Rs. 15 lakhs as defined by the IRDAI.`,
    },
    {
      id: `cIB10`,
      title: `Pick and drop services`,
      content: `We offer pickup and drop services at selected locations. As per this service, your damaged vehicle is repaired at our network garage and we deliver it back to you in 3 working days.`,
    },
  ],
};
const carInsAdvantages = {
  title: `Advantages of Comprehensive Car Insurance`,
  desc: `Car owners might be aware of the fact that they need to purchase car insurance along with their car. However, they might not always be aware of the following points:`,
  descList: [
    {
      id: `dL1`,
      content: `➢     Car insurance is mandatory as per The Motor Vehicles Act, 1988`,
    },
    {
      id: `dL2`,
      content: `➢     It needs to be renewed before expiry to keep it active`,
    },
    {
      id: `dL3`,
      content: `➢     There are two types of policies: Third-party Liability and Comprehensive`,
    },
    {
      id: `dL4`,
      content: `➢     You have the option of purchasing a car insurance plan of your choice; there is no compulsion of sticking to what the car dealer suggests`,
    },
    {
      id: `dL5`,
      content: `➢     Buying car insurance online is easy and convenient`,
    },
  ],
  list: [
    {
      id: `cIA1`,
      title: `Third-party Liability Cover`,
      content: `A Comprehensive insurance plan includes the mandatory aspect associated with a car insurance policy. It covers injury to third party or damage to third party’s property caused due to the insured car.`,
    },
    {
      id: `cIA2`,
      title: `Personal Accident Cover`,
      content: `Recently, this component of a car insurance policy was revised and the cover was increased from Rs. 2 lakhs to Rs. 15 lakhs. What this means, in case you are injured due to an accident involving your insured car, the insurance company will take care of medical expenses up to Rs. 15 lakhs as per the terms and conditions of the policy.`,
    },
    {
      id: `cIA3`,
      title: `Car Accident`,
      content: `A car accident has the potential to be devastating; mentally, physically, and financially. Unlike a Third-party Liability policy, a Comprehensive plan covers damages to your car as well. Thus, if your car is damaged due to an accident, the insurance company will take care of the expenses incurred for repairing the insured vehicle.`,
    },
    {
      id: `cIA4`,
      title: `Damages Due to Fire`,
      content: `A Comprehensive plan covers damages to your car caused due to fire. Fire due to self-ignition, explosion, lightning etc. are usually covered under this plan.`,
    },
    {
      id: `cIA5`,
      title: `Car Theft`,
      content: `Imagine you park your car in a mall’s parking lot and fail to find it while exiting the mall! It would be devastating, wouldn’t it? A Comprehensive plan covers car theft. You shall receive the vehicle’s Insured Declared Value (IDV) in case of car theft, after the claim settlement process.`,
    },
    {
      id: `cIA6`,
      title: `Calamities`,
      content: `Nowadays, cities are vulnerable to flooding a lot more than they used to in the past. Be it natural calamities such as floods or manmade calamities such as riots, damages to your car will be covered if you purchase a Comprehensive policy.`,
    },
    {
      id: `cIA7`,
      title: `Add-ons`,
      content: `You also have the option of purchasing additional covers along with your Comprehensive plan. Note that these covers cannot be purchased on a stand-alone basis or along with a Third-party Liability policy. Add-ons are designed to cover the exceptions of a policy and to lend a bit of personalization to your car insurance cover. Here’s a list of popular car insurance Add-ons:`,
    },
  ],
};
const easyClaim = {
  title: `Claims are easy with ACKO`,
  desc: `Skip cumbersome paperwork, raise your claim online, and experience a hassle-free journey with ACKO. Our 24x7 claim registrations do not require you to submit physical documents. Visit our website www.acko.com or mobile app and select “claim now” to raise your claim with a few clicks. Below are the features of ACKO’s two-wheeler insurance claim process.`,
  list: [
    {
      id: `eC1`,
      img: claimImg1,
      title: `Same day claim settlement`,
      content: `You do not have to wait for days for the claim to be settled, especially for minor damages. ACKO will settle the claim on the same day.`,
    },
    {
      id: `eC2`,
      img: claimImg2,
      title: `Advance cash settlement`,
      content: `In case of minor damages to your bike, ACKO will settle the claim instantly. You can choose a garage of your choice to fix the damage.`,
    },
    {
      id: `eC3`,
      img: claimImg3,
      title: `Instant settlement`,
      content: `Login and upload the picture of the bike damages, and get an instant settlement. This process usually takes less than 2 hours.`,
    },
  ],
};
const needHelp = {
  title: `Need more help?`,
  desc: `Have queries related to ACKO’s car insurance policies? Refer to Policy Wordings here: https://www.acko.com/download/ for detailed information or reach out to us via email or phone using the information below.`,
  list: [
    {
      id: `nH1`,
      title: `Email`,
      content: `Write to us at hello@acko.com`,
    },
    {
      id: `nH2`,
      title: `Phone`,
      content: `Call us on 1800 266 2256`,
    },
  ],
};
const need4CarIns = {
  title: `The need for car insurance in India`,
  desc: `As per the report by Insurance Information Bureau (IIB), approximately 23 crore vehicles were running on the Indian roads as of 31st March 2019. While India ranked fourth across the globe with respect to the vehicles manufactured in 2019, the bike and car insurance penetration showed signs of worry. Out of 23 crore vehicles in the country, 57% were uninsured. If we do a quick calculation, approx. 13 crore Indian vehicles did not even have a mandatory Third-party insurance policy. Here are a few more reasons why insurance for cars/bikes is necessary in our country.`,
  list: [
    {
      id: `n4CI1`,
      img: chartImg1,
      title: `Increase in car and bike thefts`,
      content: `In 2019, close to 2.4 lakh car and bike thefts were reported in the country as per the report released by National Crime Records Bureau (NCRB).

      This is a Compound Annual Growth Rate (CAGR) of close to 2% over the last 3 years. This means 105 vehicles were stolen out of every 1 lakh vehicle in India, with only 25% getting recovered later.
      
      Hence, it is increasingly important to insure your car with Comprehensive Car Insurance to avoid financial loss in case of theft. If we further dissect this data statewise, 11 states contributed to 70% of vehicle thefts in India.`,
    },
    {
      id: `n4CI2`,
      img: chartImg2,
      title: `Rising number of road accidents`,
      content: `In 2019, our country reported close to 4.4 lakh road accidents as per the NCRB report. That is a perturbing number of approx. 191 road accidents per 1 lakh vehicles in India. In these accidents, around 1.54 lakh people died and close ~4.4 lakh people reported injuries.

      As per the chart, there has been a steady decrease in road accidents since 2015. However, that’s not enough recovery, as India ranked third in the world when it came to the number of road accidents in 2018.`,
    },
  ],
};
const underPenetrationIns = {
  title: `The need for car insurance in India`,
  desc: `As per the report by Insurance Information Bureau (IIB), approximately 23 crore vehicles were running on the Indian roads as of 31st March 2019. While India ranked fourth across the globe with respect to the vehicles manufactured in 2019, the bike and car insurance penetration showed signs of worry. Out of 23 crore vehicles in the country, 57% were uninsured. If we do a quick calculation, approx. 13 crore Indian vehicles did not even have a mandatory Third-party insurance policy. Here are a few more reasons why insurance for cars/bikes is necessary in our country.`,
  list: [
    {
      id: `uPI1`,
      img: chartImg3,
      title: `Total vehicle uninsured population`,
      content: `For FY18-19, the total number of vehicles on the Indian roads was approx. 23 crores. Only 43% were insured. While 66% of two-wheelers remained uninsured (up from 62% in FY16-17), the private car uninsured proportion stood at 11% (up from 7% in FY16-17).`,
    },
    {
      id: `uPI2`,
      img: chartImg4,
      title: `Uninsured proportion in Indian states`,
      content: `There were 21 states/union territories where the uninsured rate was more than 50%. Meghalaya topped the list with 86% uninsured vehicles, whereas Kerala performed comparatively better with just 17% uninsured cars and bikes in the state. 11 major states registered an uninsured proportion of more than 50%.`,
    },
  ],
};
export {
  ackoContent,
  notCovered,
  expiredInsurance,
  buyCarIns,
  buyBikeIns,
  reponsibleFactor,
  claimProcess,
  addOneCarIns,
  growthCarInsIndia,
  glimpseInsIndustry,
  whereShouldBuy,
  bikeInsTerminologies,
  benefitsRenewBikeIns,
  carInsBenefits,
  carInsAdvantages,
  easyClaim,
  needHelp,
  need4CarIns,
  underPenetrationIns,
};
